import { createAsyncThunk } from "@reduxjs/toolkit";
import { postLogin, postLogout } from "../../../helpers/backend_helper";

export const loginUser = createAsyncThunk(
  "login/loginUser",
  async (params: { user: any, history: any }, { rejectWithValue }) => {
    try {
      const response: any = await postLogin({
        document: params.user.document,
        password: params.user.password,
      });

      sessionStorage.setItem("authUser", JSON.stringify(response));
      params.history("/users");
      return response.data; // becomes action.payload on fulfilled
    } catch (error: any) {
      const message = error.includes('401') ? 'Usuario o contraseña incorrectos' : error;
      return rejectWithValue(message);
    }
  }
);

export const logoutUser = createAsyncThunk(
  "login/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const authUserStr = sessionStorage.getItem("authUser");
      if (authUserStr) {
        try {
          const authUser = JSON.parse(authUserStr);
          const userId = authUser?.user?.id || authUser?.id || authUser?.data?.id || authUser?.data?.user?.id;
          if (userId) {
            await postLogout({ id: userId }).catch(() => {});
          }
        } catch (e) {
          // Ignorar error de parseo al salir
        }
      }
      sessionStorage.removeItem("authUser");
      return true;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
